import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import watsIcon from '../assest/home/5357b4eb16238760df0ba166628f1cee41086e44.png';
import styleProg from '../css/backgrounds/programming.module.css';
import '../css/AllServices.css';

function Programming() {
    const serviceRefs = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-in');
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            }
        );

        serviceRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            serviceRefs.current.forEach((ref) => {
                if (ref) observer.unobserve(ref);
            });
        };
    }, []);

    const addToRefs = (el, index) => {
        if (el && !serviceRefs.current.includes(el)) {
            serviceRefs.current[index] = el;
        }
    };

    return (
        <div className="services-name">
            <div className={`${styleProg.back1} service-item`} ref={(el) => addToRefs(el, 0)}>
                <h1>تطبيقات</h1>
                <div>
                    <span><Link to='/services/appDev'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966554069111?text=السلام عليكم. عندي استفسار في مجال التطبيقات'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleProg.back2} service-item`} ref={(el) => addToRefs(el, 1)}>
                <h1>مواقع الكترونية</h1>
                <div>
                    <span><Link to='/services/web'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966554069111?text=السلام عليكم. عندي استفسار في مجال المواقع الالكترونية'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleProg.back3} service-item`} ref={(el) => addToRefs(el, 2)}>
                <h1>الدعم الفني</h1>
                <div>
                    <span><Link to='/services/technicSupport'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966554069111?text=السلام عليكم. اريد دعم فني'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleProg.back4} service-item`} ref={(el) => addToRefs(el, 3)}>
                <h1>نظام الموارد البشرية</h1>
                <div>
                    <span><Link to='/services/hr'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966554069111?text=السلام عليكم. اريد استفسر عن نظام الموارد البشرية'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleProg.back5} service-item`} ref={(el) => addToRefs(el, 4)}>
                <h1>نظام المحاسبة</h1>
                <div>
                    <span><Link to='/services/accountSys'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966554069111?text=السلام عليكم. عندي استفسار في النظام المحاسبي'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleProg.back6} service-item`} ref={(el) => addToRefs(el, 5)}>
                <h1>نظام إداري</h1>
                <div>
                    <span><Link to='/services/AdminSystem'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966554069111?text=السلام عليكم. اريد استفسر في النظام الاداري'>أطلب الان</Link>
                    </span>
                </div>
            </div>
            <div className={`${styleProg.back7} service-item`} ref={(el) => addToRefs(el, 6)}>
                <h1>نظام CRM</h1>
                <div>
                    <span><Link to='/services/crm'>التفاصيل</Link></span>
                    <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                        <Link to='https://wa.me/+966554069111?text=السلام عليكم. اريد استفسر عن نظام ال crm'>أطلب الان</Link>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Programming